/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber0Small = createReactComponent("outline", "number-0-small", "IconNumber0Small", [["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-0" }]]);

export { IconNumber0Small as default };
//# sourceMappingURL=IconNumber0Small.mjs.map
